import CashierNavbar from '../components/layout/Cashier/CashierNavbar'
import NewClientModal from '../components/modals/Cashier/NewClientModal'
import { selectCurrentAdditionalModalType, selectCurrentShowTypeOfModal, selectCurrentThirdModalType, selectSelectedId } from '../features/modal/modalSlice'
import { useSelector } from 'react-redux'
// import ClientPackageDetails from '../components/modals/Cashier/ClientPackageDetails'
import AddPackageModal from '../components/modals/Admin/AddPackageModal'
import PackageDetailsItem from '../components/modals/Cashier/PackageDetailsItem'
import ClientPackages from '../components/modals/Cashier/ClientPackages'
import ContainerDashboard from '../components/layout/ContainerDashboard'
import { selectPackageViewId } from '../features/client/clientSlice'
import ClientPackageDetails from '../components/modals/Cashier/ClientPackageDetails'

export default function CashierDashboard() {

    const typeOfModalShow = useSelector(selectCurrentShowTypeOfModal);
    const typeOfAddModal = useSelector(selectCurrentAdditionalModalType);
    const typeOfThirdModal = useSelector(selectCurrentThirdModalType);
    const selectedPackageId = useSelector(selectSelectedId);
    const packageSelectedIdView = useSelector(selectPackageViewId)
    
    return (
        <>
            <div className='h-screen flex flex-col bg-gray-100'>
                <CashierNavbar />
                <ContainerDashboard/>
            </div>
            {typeOfModalShow === 'newClient' && (
                <NewClientModal typeOfAction={'newClient'} />
            )}
            
            {typeOfAddModal === 'viewClientPackageSummary' && (
                <ClientPackageDetails/>
            )}

            {typeOfThirdModal === 'viewPackageSelected' && (
                <PackageDetailsItem
                    selectedId={packageSelectedIdView ?? null}
                    // selectedId={selectedPackageId}
                />
            )}
            {typeOfThirdModal === 'viewPackageSelected' && (
                <PackageDetailsItem
                    selectedId={packageSelectedIdView ?? null}
                    // selectedId={selectedPackageId}
                />
            )}

            {typeOfAddModal === 'viewDefaultPackage' && (
                <PackageDetailsItem
                    selectedId={packageSelectedIdView ?? null}
                />
            )}
            {typeOfAddModal === 'viewPackageItem' && (
                <PackageDetailsItem
                    selectedId={packageSelectedIdView ?? null}
                />
            )}

            {typeOfAddModal === 'addPackage' && (
                <AddPackageModal />
            )} 

            {typeOfAddModal === 'viewClientPackages' && (
                <ClientPackages/>
            )} 

            {typeOfAddModal === 'updateClient' && (
                <NewClientModal
                    typeOfAction={'update'}
                />
            )} 
        </>
    )
}